import ErrorIcon from '@mui/icons-material/Error';
import LockIcon from '@mui/icons-material/Lock';
import InputAdornment from '@mui/material/InputAdornment';

import { PaymentFieldTypes } from 'payments/constants/card';
import { LIGHT_SOY } from 'reservations/brand/constants';

type Props = {
  name: string;
  hasError: boolean;
};

export function PaymentTextInputAdornment({ name, hasError }: Props) {
  if (hasError) {
    return (
      <InputAdornment position="start">
        <ErrorIcon color="error" fontSize="small" />
      </InputAdornment>
    );
  }

  if (name === PaymentFieldTypes.CARD_NUMBER) {
    return (
      <InputAdornment position="start">
        <LockIcon fontSize="small" sx={{ fill: LIGHT_SOY }} />
      </InputAdornment>
    );
  }

  return null;
}
